import { BulkAction } from 'src/app/shared/interfaces'

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'
import { DataTable } from '@pascalhonegger/ng-datatable'

import { Course } from '../course'
import { Observable, Subject } from 'rxjs'
import { Tag } from '../../tag/tag'
import { Dictionary } from '@ngrx/entity'
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  take
} from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { tagSelectors } from '../../tag/tag.selectors'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { translationSelectors } from '../../translation/translation.selectors'
import { RequestQueryBuilder, CondOperator } from '@nestjsx/crud-request'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import DEBOUNCED_TIME = Constants.DEBOUNCED_TIME
import { Constants } from 'src/app/shared/constants'
import { courseActions } from '../course.actions'

@UntilDestroy()
@Component({
  selector: 'course-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class CourseTableComponent implements OnInit {
  @Input() tableData: Course[]
  @Input() bulkActions: BulkAction[] = []
  @Input() height: string = 'auto'
  @Output() onBulkAction = new EventEmitter<any>()
  @Output() onClickRow = new EventEmitter<any>()

  @ViewChild('dataTable', { static: true }) dataTable: DataTable

  public filterTerm: string = ''
  public allCheckedToggle: boolean = false
  public checkedIds: Map<number, boolean> = new Map()
  public tagEntities$: Observable<Dictionary<Tag>>
  public selectedLanguage$: Observable<string>

  public searchTerm$ = new Subject<string>()

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.tagEntities$ = this.store.select(tagSelectors.selectEntities)

    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )

    this.searchTerm$
      .pipe(
        distinctUntilChanged(),
        debounceTime(DEBOUNCED_TIME),
        untilDestroyed(this),
        filter((s) => s.length > 2)
      )
      .subscribe((term) => {
        this.store.dispatch(
          courseActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                description: { [CondOperator.CONTAINS_LOW]: term }
              },
              join: [{ field: 'tags' }, { field: 'translations' }]
            })
          })
        )
      })
  }

  public onRowClicked(row: Course) {
    this.onClickRow.emit(row)
  }

  public onCheckRow(targetRow: Course) {
    this.checkedIds.set(
      targetRow.id,
      !Boolean(this.checkedIds.get(targetRow.id))
    )
  }

  public onToggleAllChecked() {
    this.allCheckedToggle = !this.allCheckedToggle

    this.dataTable.data.forEach((row) =>
      this.checkedIds.set(row.id, this.allCheckedToggle)
    )
  }

  public onClickBulkAction(bulkOption: string) {
    console.log('onClickBulkAction')
  }

  public getTags(course: Course): Observable<Tag[]> {
    return this.tagEntities$.pipe(
      map((tagEntities) => course?.tags?.map((tagId) => tagEntities[tagId]))
    )
  }

  public onSearch(value) {
    this.searchTerm$.next(value)
  }

  public hasTranslation(course: Course, lang: string): Observable<boolean> {
    return this.store.select(translationSelectors.selectEntities).pipe(
      take(1),
      map((translationEntities) => {
        if (!course?.translations?.length) {
          return false
        }
        return course.translations.find(
          (translationId) => translationEntities[translationId].language == lang
        )
      })
    )
  }
}
